import { makeAutoObservable, runInAction } from 'mobx'
import { TStatus } from '@common/enum/refund.enum'
import OrderAPI from '@api/order.api'

/** 默认配置 */
const defaultConfig = {
  eatType: [],
  orderReasonPlanId: 0,
  orderReasons: [],
  refuseOrderReasons: [],
  status: TStatus.Disable,
}

class RefundMobx {
  constructor () {
    makeAutoObservable(this)
  }
  /** 退款配置 */
  refundConfig = defaultConfig
  /** 获取手机退款配置 */
  async getMobileRefundPlan () {
    try {
      const res = await OrderAPI.getMobileRefundPlan()
      let _refundData = this.refundConfig
      if (res?.result) {
        const { eatType = [], orderReasonPlanId, orderReasons = [], refuseOrderReasons = [], status = TStatus.Disable } = res?.result
        _refundData = {
          eatType,
          orderReasonPlanId,
          orderReasons: orderReasons || [],
          refuseOrderReasons: refuseOrderReasons || [],
          status,
        }
        runInAction(() => {
          if (status === TStatus.Enable) {
            this.setRefundConfig(_refundData)
          } else {
            this.setRefundConfig(defaultConfig)
          }
        })
      } else {
      }
    } catch (error) {
      console.log(error, 'error')
    }
  }
  setRefundConfig (data) {
    this.refundConfig = {
      ...data
    }
  }
}

export default new RefundMobx()
